import { EMPTY_OBJECT } from '../../../../constants/common'
import { getEntityActionTypeSelectOptions } from '../../../Entity'
import { FormModal } from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'
import { MODAL_HEADER_VARIANT } from '../../../Modal'

import {
  BUILDING_EDIT_PROPERTY_OWNERS_FORM_BODY_PROPS,
  QA_NAME_EDIT_PROPERTY_OWNERS_MODAL,
} from './BuildingsEditPropertyOwnersActionModal.constants'
import {
  getInitialValues,
  getPayload,
  getValidationSchema,
} from './BuildingsEditPropertyOwnersActionModal.utils'
import { FormFields } from './FormFields'

function BuildingsEditPropertyOwnersActionModal({
  formFieldsProps: {
    actionTypes = Object.values(getEntityActionTypeSelectOptions()),
    ...formFieldsProps
  } = EMPTY_OBJECT,
  itemAction,
  users,
  onSubmit,
  ...restProps
}) {
  const initialValues = getInitialValues({ itemAction, users })

  const validationSchema = getValidationSchema({ initialValues, itemAction })

  function handleSubmit({ values }) {
    const payload = getPayload(values)

    onSubmit({
      actionType: values[FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME],
      value: payload,
    })
  }

  return (
    <FormModal
      {...restProps}
      Fields={FormFields}
      containerProps={{
        headerVariant: MODAL_HEADER_VARIANT.EDIT,
        qaName: QA_NAME_EDIT_PROPERTY_OWNERS_MODAL,
      }}
      formBodyProps={BUILDING_EDIT_PROPERTY_OWNERS_FORM_BODY_PROPS}
      formFieldsProps={{ ...formFieldsProps, actionTypes }}
      formTitle='Modal.EditPropertyOwnersTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    />
  )
}

export default BuildingsEditPropertyOwnersActionModal
